import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import Header from './components/Header';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import WhyThisCourse from './components/WhyThisCourse';
import InstructorSection from './components/InstructorSection';
import LearningAtmosphereSection from './components/LearningAtmosphereSection';
import BenefitsSection from './components/BenefitsSection';
import StorySection from './components/StorySection';
import FAQSection from './components/FAQSection';
import BonusSection from './components/BonusSection';
import PricingSection from './components/PricingSection';
import UrgencySection from './components/UrgencySection';
import Footer from './components/Footer';
import './App.css';

const { FiPhone, FiCalendar } = FiIcons;

function App() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingCTA(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Update document title dynamically
    document.title = 'BAZI MASTERY ปาจื้อเรียกทรัพย์ | หลักสูตรปาจื้อเพื่อการเงิน วันที่ 12 กรกฎาคม 2568';
  }, []);

  const handleBooking = () => {
    window.open('https://www.fengshuix.com/event-details/wi-cha-pa-cux-reiyk-thraphy-bazi-chinese-astrology-for-got-money', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      <Header onBooking={handleBooking} />
      <Hero onBooking={handleBooking} />
      <PainPoints />
      <WhyThisCourse onBooking={handleBooking} />
      <InstructorSection onBooking={handleBooking} />
      <LearningAtmosphereSection onBooking={handleBooking} />
      <BenefitsSection onBooking={handleBooking} />
      <StorySection />
      <FAQSection />
      <BonusSection />
      <PricingSection onBooking={handleBooking} />
      <UrgencySection onBooking={handleBooking} />
      <Footer onBooking={handleBooking} />

      {/* Floating CTA Button */}
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ 
          opacity: showFloatingCTA ? 1 : 0, 
          y: showFloatingCTA ? 0 : 100 
        }}
        className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50"
      >
        <button
          onClick={handleBooking}
          className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-8 py-4 rounded-full shadow-2xl hover:shadow-amber-500/25 transition-all duration-300 font-bold text-lg flex items-center gap-3 animate-pulse"
        >
          <SafeIcon icon={FiPhone} className="text-xl" />
          จองที่นั่งเดี๋ยวนี้!
        </button>
      </motion.div>
    </div>
  );
}

export default App;